import { Injectable } from '@angular/core';
import { CommonConstants } from '../utilities/commonConstants';
import { SessionHandlerService } from './sessionHandler.service';

declare const initiPageInfo: any;
declare const applicationCreated: any;
declare const planListingDisplayed: any;
declare const refinement: any;
declare const quoteCreated: any;
declare const detailsEdit: any;
declare const proposerDetailsCreated: any;
declare const paymentStarted: any;
declare const paymentCompleted: any;
declare const paymentFailed: any;
declare const proceedAfterPayment: any;
declare const insuredDetailsCreated: any;
declare const backButton: any;
declare const addressDetailsCreated: any;
declare const nomineeDetailsCreated: any;
declare const healthDeclarationCreated: any;
declare const policyBookingStarted: any;
declare const policyIssued: any;
declare const crossellProducts: any;
declare const applicationResumeStart: any;
declare const applicationResumeCompleted: any;
declare const triggerAPIFailure: any;
declare const exploreMoreProducts: any;

@Injectable({
    providedIn: 'root'
})
export class adobe_analytics_service {
    private processId: string;
    private quoteId: string;
    private applicationId: string;
    private productId: string;
    private productName = { HGI: 'Health Insurance', GHGI: 'Group Health Insurance' };
    constructor(private _sessionHandlerService: SessionHandlerService) {
    }
    public initiPageInfo() {
        initiPageInfo('insurance', 'Health Insurance', 'open arch:health insurance', 'HGI', 'Health Insurance', '')
    }
    public applicationCreated(applicantKey, mobileNo, dob, insuringFor, pinCode, city, appQuoteCriteriaId, processId, nextTaskKey, stagePercentage) {
        const productId = 'HGI';
        const productName = this.productName.HGI;
        applicationCreated(applicantKey, mobileNo, dob, insuringFor, pinCode, city, appQuoteCriteriaId, productId, productName, processId, nextTaskKey, stagePercentage)
    }
    public planListingDisplayed(applicantKey, quoteID, quoteIds, planList, emiCardEligibility, nextTaskKey, stagePercentage) {
        const processId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.processId);
        planListingDisplayed(applicantKey, quoteID, quoteIds, planList, emiCardEligibility, processId, nextTaskKey, stagePercentage)
    }
    public refinement(applicantKey, quoteID, changeType, changePosition, planList, emiCardEligibility) {
        refinement(applicantKey, quoteID, changeType, changePosition, planList, emiCardEligibility)
    }
    public quoteCreated(applicantKey, quoteID, planDetail, topUpDetails, sumInsured, premiumAmount, tenure, processId, nextTaskKey, stagePercentage) {
        quoteCreated(applicantKey, quoteID, planDetail, topUpDetails, sumInsured, premiumAmount, tenure, processId, nextTaskKey, stagePercentage)
    }
    public detailsEdit(detailsEditType, stageWhereEditInitiated, nextTaskKey) {
        const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
        detailsEdit(applicantKey, detailsEditType, stageWhereEditInitiated, nextTaskKey)
    }
    public proposerDetailsCreated(firstName, lastName, emailID, dob, mobileNo, gender, emiCardEligibility, processId, nextTaskKey, stagePercentage) {
        const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
        const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId);
        proposerDetailsCreated(applicantKey, quoteID, firstName, lastName, emailID, dob, mobileNo, gender, emiCardEligibility, processId, nextTaskKey, stagePercentage)
    }
    public paymentStarted(paymentInstrument, systemPaymentId, nextTaskKey, stagePercentage) {
        const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
        const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId);
        const processId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.processId);
        paymentStarted(applicantKey, quoteID, paymentInstrument, systemPaymentId, processId, nextTaskKey, stagePercentage)
    }
    public paymentCompleted(planDetail, topUpDetails, paymentInstrument, systemPaymentId, referenceNumber, orderId, paymentId, orderAmount, gstAmount, nextTaskKey, stagePercentage) {
        const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
        const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId);
        const processId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.processId);
        paymentCompleted(applicantKey, quoteID, planDetail, topUpDetails, paymentInstrument, systemPaymentId, referenceNumber, orderId, paymentId, orderAmount, gstAmount, processId, nextTaskKey, stagePercentage)
    }
    public paymentFailed(planDetail, topUpDetails, rejectReason, paymentInstrument, nextTaskKey, stagePercentage) {
        const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
        const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId);
        const processId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.processId);
        paymentFailed(applicantKey, quoteID, planDetail, topUpDetails, rejectReason, paymentInstrument, processId, nextTaskKey, stagePercentage)
    }
    public proceedAfterPayment(nextTaskKey, stagePercentage) {
        const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
        const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId);
        const processId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.processId);
        proceedAfterPayment(applicantKey, quoteID, processId, nextTaskKey, stagePercentage)
    }
    public insuredDetailsCreated(applicantId, firstName, lastName, emailID, dob, mobileNo, gender, nextTaskKey, stagePercentage) {
        const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
        const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId);
        const processId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.processId);
        insuredDetailsCreated(applicantKey, applicantId, quoteID, firstName, lastName, emailID, dob, mobileNo, gender, processId, nextTaskKey, stagePercentage)
    }
    public backButton(stageWhereBackInitiated, nextTaskKey, stagePercentage) {
        const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
        backButton(applicantKey, stageWhereBackInitiated, nextTaskKey, stagePercentage)
    }
    public addressDetailsCreated(applicantId, addressId, addressType, address1, address2, pincode, city, state, nextTaskKey, stagePercentage) {
        const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
        const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId);
        const processId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.processId);
        addressDetailsCreated(applicantKey, applicantId, quoteID, addressId, addressType, address1, address2, pincode, city, state, processId, nextTaskKey, stagePercentage)
    }
    public nomineeDetailsCreated(applicantId, firstName, lastName, relationship, nextTaskKey, stagePercentage) {
        const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
        const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId);
        const processId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.processId);
        nomineeDetailsCreated(applicantKey, applicantId, quoteID, firstName, lastName, relationship, processId, nextTaskKey, stagePercentage)
    }
    public healthDeclarationCreated(applicantId, healthDeclarationFlag, nextTaskKey, stagePercentage) {
        const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
        const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId);
        const processId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.processId);
        healthDeclarationCreated(applicantKey, applicantId, quoteID, healthDeclarationFlag, processId, nextTaskKey, stagePercentage)
    }
    public policyBookingStarted(applicantId, goGreenFlag, nextTaskKey, stagePercentage) {
        const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
        const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId);
        const processId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.processId);
        policyBookingStarted(applicantKey, applicantId, quoteID, goGreenFlag, processId, nextTaskKey, stagePercentage)
    }
    public policyIssued(policyStatus, policyObj, nextTaskKey, stagePercentage) {
        const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
        const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId);
        const processId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.processId);
        policyIssued(applicantKey, quoteID, policyStatus, policyObj, processId, nextTaskKey, stagePercentage)
    }
    public crossellProducts(currentStage, productCode, productName, bannerName, bannerPosition, bannerDiscription, destinationURL) {
        const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
        const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId);
        crossellProducts(applicantKey, quoteID, currentStage, productCode, productName, bannerName, bannerPosition, bannerDiscription, destinationURL)
    }
    public applicationResumeStart(applicantKey, mobileNo, dob, pinCode, insuringFor, appQuoteCriteriaId, productId, productName, nextTaskKey, stagePercentage, applicantId, planDetail, topUpDetails) {
        const processId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.processId);
        applicationResumeStart(applicantKey, mobileNo, dob, pinCode, insuringFor, appQuoteCriteriaId, productId, productName, processId, nextTaskKey, stagePercentage, applicantId, planDetail, topUpDetails)
    }
    public applicationResumeCompleted(applicantKey, mobileNo, dob, insuringFor, pinCode, appQuoteCriteriaId, productId, productName, resumeWithOTP, nextTaskKey, stagePercentage) {
        const processId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.processId);
        applicationResumeCompleted(applicantKey, mobileNo, dob, insuringFor, pinCode, appQuoteCriteriaId, productId, productName, resumeWithOTP, processId, nextTaskKey, stagePercentage)
    }
    public exploreMoreProducts(currentStage, destinationURL) {
        const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
        const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId);
        exploreMoreProducts(applicantKey, quoteID, currentStage, destinationURL)
    }
    private triggerAPIFailure(errorCode, errorName, apiName) {
        triggerAPIFailure(errorCode, errorName, apiName);
    }
    public triggerAPIFailureService(payload, serviceName) {
        if (payload.errorBean && payload.errorBean !== undefined) {
            this.triggerAPIFailure(payload.errorBean[0].errorCode, payload.errorBean[0].errorMessage, serviceName);
        } else if (payload.length && payload[0].errorCode) {
            this.triggerAPIFailure(payload[0].errorCode, payload[0].errorMessage, serviceName);
        }
    }
}
